import { render, staticRenderFns } from "./appliShare.vue?vue&type=template&id=6edfbd4a&scoped=true&"
import script from "./appliShare.vue?vue&type=script&lang=js&"
export * from "./appliShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edfbd4a",
  null
  
)

export default component.exports